(() => {
  'use strict';
  if (window.AWCompatibilityAvailability?.version) return;

  const normalize = (value = '') => String(value || '').trim().toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').replace(/&/g, ' et ')
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const split = (value = '') => String(value || '').split(',').map(normalize).filter(Boolean);
  const splitIds = (value = '') => String(value || '').split(',').map((item) => item.trim()).filter(Boolean);
  const urlKey = (value = '') => {
    try { return new URL(value, location.origin).pathname.replace(/\/$/, ''); }
    catch (_) { return String(value || '').split('?')[0].replace(/\/$/, ''); }
  };

  const currentModelNode = (root) => {
    if (root.dataset.modelPage !== 'true') return null;
    const marker = '/pages/compatibilite-airsoft-';
    const raw = location.pathname.includes(marker) ? location.pathname.split(marker)[1] : '';
    const handle = normalize(raw || '');
    if (!handle) return null;
    return [...document.querySelectorAll('[data-aw-tool-model]')]
      .find((node) => normalize(node.dataset.handle || '') === handle) || null;
  };

  const context = (root) => {
    const modelNode = currentModelNode(root);
    return {
      platform: normalize(
        modelNode?.dataset.platform ||
        window.AWAirsoftContext?.current?.()?.platform ||
        localStorage.getItem('aw_selected_platform') || ''
      ),
      exact: modelNode ? normalize(modelNode.dataset.handle || '') : '',
      exactProductIds: new Set(splitIds(modelNode?.dataset.productIds || ''))
    };
  };

  const metadata = (root) => {
    const source = root.querySelector('[data-aw-product-source]');
    const map = new Map();
    source?.querySelectorAll('[data-aw-product]').forEach((node) => {
      const key = urlKey(node.dataset.url || '');
      if (!key) return;
      map.set(key, {
        id: String(node.dataset.productId || '').trim(),
        available: node.dataset.available !== 'false',
        exactModels: split(node.dataset.exactModels),
        platforms: split(node.dataset.platforms)
      });
    });
    return map;
  };

  const exactMatch = (meta, exact, exactProductIds) => Boolean(
    meta && (
      (exact && meta.exactModels?.includes(exact)) ||
      (meta.id && exactProductIds?.has(meta.id))
    )
  );

  const tier = (meta, exact, exactProductIds) => {
    const isExact = exactMatch(meta, exact, exactProductIds);
    if (meta?.available && isExact) return 0;
    if (meta?.available) return 1;
    if (isExact) return 2;
    return 3;
  };

  const ensureStyles = () => {
    if (document.getElementById('AwCompatibilityAvailabilityCss')) return;
    const style = document.createElement('style');
    style.id = 'AwCompatibilityAvailabilityCss';
    style.textContent = '.aw-compatibility-search__badges .is-aw-exact{background:#261010;border-color:#7e2323;color:#fff}.aw-compatibility-search__badges .is-aw-unavailable{background:#171717;border-color:#454545;color:#b7b7b7}.aw-compatibility-search__product.is-aw-unavailable-card{opacity:.78}.aw-compatibility-search__product.is-aw-unavailable-card .aw-compatibility-search__product-media{filter:saturate(.7)}';
    document.head.appendChild(style);
  };

  const updateCoverage = (root, map, platform, exact, exactProductIds) => {
    if (!exact) return;
    const relevant = [...map.values()].filter((item) => !platform || item.platforms.includes(platform));
    const exactItems = relevant.filter((item) => exactMatch(item, exact, exactProductIds));
    const visible = exactItems.length;
    const available = exactItems.filter((item) => item.available).length;
    const documented = exactProductIds.size;
    const known = Math.max(documented, visible);
    const note = root.querySelector('[data-aw-tools-exact-coverage]');
    if (!note) return;

    if (!known) {
      note.textContent = 'Couverture modèle exact : aucune relation produit → modèle exact n’est encore documentée dans AW. Les résultats ci-dessous sont des correspondances de plateforme ou de profil à contrôler avant commande ou montage.';
    } else if (!visible) {
      note.textContent = `Couverture modèle exact : ${known} référence${known > 1 ? 's sont' : ' est'} documentée${known > 1 ? 's' : ''} dans AW, mais aucune n’est actuellement visible dans la boutique. Les correspondances de plateforme restent disponibles à titre de recherche, sans validation modèle exact.`;
    } else if (!available) {
      note.textContent = `Couverture modèle exact : ${known} référence${known > 1 ? 's' : ''} documentée${known > 1 ? 's' : ''}, dont ${visible} visible${visible > 1 ? 's' : ''} dans la boutique ; aucune n’est disponible actuellement. Les correspondances disponibles de plateforme sont donc classées avant ces références.`;
    } else {
      note.textContent = `Couverture modèle exact : ${known} référence${known > 1 ? 's' : ''} documentée${known > 1 ? 's' : ''}, dont ${visible} visible${visible > 1 ? 's' : ''} et ${available} disponible${available > 1 ? 's' : ''} actuellement.`;
    }

    root.dataset.awExactDocumentedCount = String(documented);
    root.dataset.awExactVisibleCount = String(visible);
    root.dataset.awExactAvailableCount = String(available);
  };

  const updateTotal = (root, map, platform) => {
    if (!platform) return;
    const relevant = [...map.values()].filter((item) => item.platforms.includes(platform));
    const available = relevant.filter((item) => item.available).length;
    const total = root.querySelector('[data-aw-total-count]');
    if (total && relevant.length) {
      total.textContent = `${relevant.length} correspondance${relevant.length > 1 ? 's' : ''} référencée${relevant.length > 1 ? 's' : ''} · ${available} disponible${available > 1 ? 's' : ''}`;
    }
  };

  const decorate = (root) => {
    const grid = root.querySelector('[data-aw-products]');
    if (!grid) return;
    const map = metadata(root);
    if (!map.size) return;
    const { platform, exact, exactProductIds } = context(root);

    const cards = [...grid.querySelectorAll('.aw-compatibility-search__product')];
    const sourceExact = exact
      ? [...map.values()].filter((item) => (!platform || item.platforms.includes(platform)) && exactMatch(item, exact, exactProductIds)).length
      : 0;
    const renderedExact = cards.filter((card) => {
      const link = card.querySelector('a[href]');
      return exactMatch(link ? map.get(urlKey(link.href)) : null, exact, exactProductIds);
    }).length;

    const more = root.querySelector('[data-aw-show-more]');
    const guard = Number(root.dataset.awAvailabilityExpand || 0);
    if (sourceExact > renderedExact && more && !more.hidden && guard < 4) {
      root.dataset.awAvailabilityExpand = String(guard + 1);
      more.click();
      return;
    }

    const ranked = cards.map((card, index) => {
      const link = card.querySelector('a[href]');
      const meta = link ? map.get(urlKey(link.href)) : null;
      return { card, meta, index, tier: tier(meta, exact, exactProductIds) };
    }).sort((a, b) => a.tier - b.tier || a.index - b.index);

    const current = [...grid.querySelectorAll('.aw-compatibility-search__product')];
    if (ranked.some(({ card }, index) => current[index] !== card)) {
      ranked.forEach(({ card }) => grid.appendChild(card));
    }

    ranked.forEach(({ card, meta }) => {
      if (!meta) return;
      const badges = card.querySelector('.aw-compatibility-search__badges');
      const isExact = exactMatch(meta, exact, exactProductIds);
      let exactBadge = badges?.querySelector('[data-aw-availability-badge="exact"]');
      if (isExact && badges && !exactBadge) {
        exactBadge = document.createElement('span');
        exactBadge.className = 'is-aw-exact';
        exactBadge.dataset.awAvailabilityBadge = 'exact';
        exactBadge.textContent = 'Modèle exact documenté';
        badges.prepend(exactBadge);
      } else if (!isExact) {
        exactBadge?.remove();
      }

      card.classList.toggle('is-aw-unavailable-card', !meta.available);
      let stockBadge = badges?.querySelector('[data-aw-availability-badge="stock"]');
      if (!meta.available && badges && !stockBadge) {
        stockBadge = document.createElement('span');
        stockBadge.className = 'is-aw-unavailable';
        stockBadge.dataset.awAvailabilityBadge = 'stock';
        stockBadge.textContent = 'Indisponible actuellement';
        badges.appendChild(stockBadge);
      } else if (meta.available) {
        stockBadge?.remove();
      }
    });

    updateCoverage(root, map, platform, exact, exactProductIds);
    updateTotal(root, map, platform);
    root.dataset.awAvailabilityRanking = 'ready';
  };

  const install = (scope = document) => {
    ensureStyles();
    const roots = [];
    if (scope.matches?.('[data-aw-compatibility-search]')) roots.push(scope);
    scope.querySelectorAll?.('[data-aw-compatibility-search]').forEach((root) => roots.push(root));

    roots.forEach((root) => {
      const grid = root.querySelector('[data-aw-products]');
      if (!grid) return;
      const run = () => queueMicrotask(() => decorate(root));
      run();

      if (root.dataset.awAvailabilityObserver !== 'true' && 'MutationObserver' in window) {
        root.dataset.awAvailabilityObserver = 'true';
        let pending = false;
        new MutationObserver(() => {
          if (pending) return;
          pending = true;
          queueMicrotask(() => {
            pending = false;
            decorate(root);
          });
        }).observe(grid, { childList: true });
      }

      if (root.dataset.awAvailabilityEvents !== 'true') {
        root.dataset.awAvailabilityEvents = 'true';
        window.addEventListener('aw:compatibility-changed', run);
        window.addEventListener('aw:context-changed', run);
      }
    });
  };

  window.AWCompatibilityAvailability = {
    version: '1.1.0',
    install,
    exactSource: 'aw_replica_model.produits + product.compatibilite.modeles_exacts',
    policy: 'available-exact > available-platform > unavailable-exact > unavailable-platform'
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => install(), { once: true });
  } else {
    install();
  }
  document.addEventListener('shopify:section:load', (event) => install(event.target));
})();
